import { render } from "./heads.vue?vue&type=template&id=46c63577"
import script from "./heads.vue?vue&type=script&lang=js"
export * from "./heads.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/shinai/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__